module.exports = __webpack_public_path__ + "img/p1-c1-p1.c7df4deb.jpg";